/**
 * Maps app pathname to analytics screen name for screen_viewed events.
 */

import type { AnalyticsScreenName } from './events'
import { ANALYTICS_SCREENS } from './events'

const PATH_TO_SCREEN: Record<string, AnalyticsScreenName> = {
  '/app': ANALYTICS_SCREENS.HOME,
  '/app/': ANALYTICS_SCREENS.HOME,
  '/app/index': ANALYTICS_SCREENS.HOME,
  '/sign-in': ANALYTICS_SCREENS.SIGN_IN,
  '/sign-up': ANALYTICS_SCREENS.SIGN_UP,
  '/app/tutorial': ANALYTICS_SCREENS.TUTORIAL,
  '/app/friends': ANALYTICS_SCREENS.FRIENDS,
  '/app/create': ANALYTICS_SCREENS.CREATE,
  '/app/gameResults': ANALYTICS_SCREENS.GAME_RESULTS,
  '/app/games': ANALYTICS_SCREENS.GAMES_HUB,
  '/app/gameResults/league-detail': ANALYTICS_SCREENS.LEAGUE_DETAIL,
  '/app/league-detail': ANALYTICS_SCREENS.LEAGUE_DETAIL,
  '/app/privacy-and-data': ANALYTICS_SCREENS.PRIVACY_AND_DATA,
}

export function pathnameToScreen(pathname: string): AnalyticsScreenName | null {
  const normalized = pathname.replace(/\/$/, '') || '/'
  if (PATH_TO_SCREEN[normalized]) {
    return PATH_TO_SCREEN[normalized]
  }
  if (normalized.startsWith('/app/friends/group/')) return ANALYTICS_SCREENS.FRIENDS_GROUP
  if (normalized.startsWith('/app/friends/')) return ANALYTICS_SCREENS.FRIEND_PROFILE
  if (normalized.startsWith('/app/create/match-details/')) return ANALYTICS_SCREENS.CREATE_MATCH_DETAILS
  if (normalized.startsWith('/app/invite/')) return ANALYTICS_SCREENS.INVITE
  if (normalized.startsWith('/app/match-details/')) return ANALYTICS_SCREENS.CHALLENGE_DETAIL
  if (normalized.startsWith('/app/legal/')) return ANALYTICS_SCREENS.LEGAL_DOCUMENT
  if (normalized === '/' || normalized === '') return ANALYTICS_SCREENS.LANDING
  return null
}
